<template>
  <div>
    <div class="navigation">
      <div class="navigation-number">
        <div class="navigation-width" :class="navigationCss(1)"></div>

        <div class="navigation-width" :class="navigationCss(2)"></div>

        <div class="navigation-width" :class="navigationCss(3)"></div>

        <div class="navigation-width" :class="navigationCss(4)"></div>

        <div class="navigation-width" :class="navigationCss(5)" v-show="$route.name !== 'AccountCreate'"></div>

        <div class="navigation-width" :class="navigationCss(6)" v-show="$route.name !== 'AccountCreate'"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navigation",
  props: ["page"],
  methods: {
    navigationCss(targetPage) {
      if (this.page >= targetPage) {
        // 現在ページ以下の場合
        return ["bg-info"];
      }
    },
  },
};
</script>

<style scoped>
.navigation-number {
  display: flex;
  flex-wrap: wrap;
  color: #00a0b9;
  margin: 5% auto 7%;
  width: 50%;
  text-align: center;
}
.navigation-width {
  /* width: calc(100% / 5); */
  background: #cccccc;
  height: 15px;
  width: 15px;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  display: inline-block;
  margin: auto;
}
.bg-info {
  background-color: #00a0b9 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue